module.exports = __webpack_public_path__ + "static/media/TermsConditions_EN.1dd573b1.pdf";